import encodeHTML from 'escape-html';

interface Inputs {
  statusCode: number;
  location: string;
}

export default function redirect(it
) {
let encodeHTML = typeof _encodeHTML !== 'undefined' ? _encodeHTML : (function(doNotSkipEncoded) {
		let encodeHTMLRules = { "&": "&#38;", "<": "&#60;", ">": "&#62;", '"': "&#34;", "'": "&#39;", "/": "&#47;" },
			matchHTML = doNotSkipEncoded ? /[&<>"'\/]/g : /&(?!#?\w+;)|<|>|"|'|\//g;
		return function(code) {
			return code ? code.toString().replace(matchHTML, function(m) {return encodeHTMLRules[m] || m;}) : "";
		};
	}());let out='<!doctype html><!-- https://now.sh --><h1>Redirecting ('+( it.statusCode )+')</h1><a>'+encodeHTML( it.location )+'</a>';return out;
}